export default __webpack_public_path__ + "static/media/home.3e0ea7c5.svg";